import { store } from "@risingstack/react-easy-state";
export const featureDragStore = store({
  draggingFeatureId: null,
  draggingHandle: null,
  dragCaretPosition: null
});
export function getBasePositionFromMouseEvent(event, charWidth = 12, sequenceLength = 0) {
  if (typeof document === "undefined") return null;
  const rowElements = document.querySelectorAll(".veRowItem[data-row-start]");
  if (!rowElements || rowElements.length === 0) {
    return null;
  }
  const clientX = event.clientX;
  const clientY = event.clientY;
  let targetRowNode = null;
  let minDistanceY = Infinity;
  let closestRowNode = null;
  for (let i = 0; i < rowElements.length; i++) {
    const node = rowElements[i];
    const rect2 = node.getBoundingClientRect();
    if (clientY >= rect2.top && clientY <= rect2.bottom) {
      targetRowNode = node;
      break;
    }
    const distY = clientY < rect2.top ? rect2.top - clientY : clientY - rect2.bottom;
    if (distY < minDistanceY) {
      minDistanceY = distY;
      closestRowNode = node;
    }
  }
  const rowNode = targetRowNode || closestRowNode;
  if (!rowNode) return null;
  const rect = rowNode.getBoundingClientRect();
  const rowStart = parseInt(rowNode.getAttribute("data-row-start"), 10);
  const rowEnd = parseInt(rowNode.getAttribute("data-row-end"), 10);
  const relativeX = clientX - rect.left;
  const bpOffset = Math.floor((relativeX + charWidth / 2) / charWidth);
  let bp = rowStart + bpOffset;
  if (bp < rowStart) bp = rowStart;
  if (bp > rowEnd + 1) bp = rowEnd + 1;
  if (sequenceLength > 0 && bp > sequenceLength) bp = sequenceLength;
  if (bp < 0) bp = 0;
  return bp;
}
export function startFeatureDrag({
  event,
  handleType,
  annotation,
  charWidth = 12,
  sequenceLength = 0,
  isProtein = false,
  upsertFeature
}) {
  if (!annotation || !upsertFeature) return;
  event.preventDefault && event.preventDefault();
  event.stopPropagation && event.stopPropagation();
  const featureId = annotation.id;
  featureDragStore.draggingFeatureId = featureId;
  featureDragStore.draggingHandle = handleType;
  const initialStart = annotation.start;
  const initialEnd = annotation.end;
  let lastStart = initialStart;
  let lastEnd = initialEnd;
  let dragHasMoved = false;
  featureDragStore.dragCaretPosition = handleType === "start" ? initialStart : initialEnd + 1;
  if (typeof document !== "undefined") {
    document.body.classList.add("veFeatureDragging");
  }
  if (typeof window !== "undefined") {
    window.__veDragging = true;
  }
  const onMouseMove = (moveEvent) => {
    moveEvent.preventDefault && moveEvent.preventDefault();
    moveEvent.stopPropagation && moveEvent.stopPropagation();
    const bp = getBasePositionFromMouseEvent(
      moveEvent,
      charWidth,
      sequenceLength
    );
    if (bp === null || bp === void 0) return;
    let newStart = lastStart;
    let newEnd = lastEnd;
    if (handleType === "start") {
      let targetStart = bp;
      if (isProtein) {
        targetStart = Math.round(targetStart / 3) * 3;
      }
      newStart = Math.max(0, Math.min(targetStart, initialEnd));
      featureDragStore.dragCaretPosition = newStart;
    } else {
      let targetEnd = Math.max(0, bp - 1);
      if (isProtein) {
        targetEnd = Math.max(
          initialStart,
          Math.round((targetEnd + 1) / 3) * 3 - 1
        );
      }
      newEnd = Math.max(
        initialStart,
        Math.min(sequenceLength > 0 ? sequenceLength - 1 : targetEnd, targetEnd)
      );
      featureDragStore.dragCaretPosition = newEnd + 1;
    }
    if (newStart !== lastStart || newEnd !== lastEnd) {
      const isFirstMove = !dragHasMoved;
      lastStart = newStart;
      lastEnd = newEnd;
      dragHasMoved = true;
      const updatedFeature = {
        ...annotation,
        start: newStart,
        end: newEnd,
        ...annotation.locations && annotation.locations.length === 1 && {
          locations: [
            { ...annotation.locations[0], start: newStart, end: newEnd }
          ]
        }
      };
      upsertFeature(updatedFeature, {
        batchUndoStart: isFirstMove,
        batchUndoMiddle: !isFirstMove
      });
    }
  };
  const onMouseUp = (upEvent) => {
    upEvent.preventDefault && upEvent.preventDefault();
    upEvent.stopPropagation && upEvent.stopPropagation();
    if (typeof window !== "undefined") {
      window.removeEventListener("mousemove", onMouseMove, true);
      window.removeEventListener("mouseup", onMouseUp, true);
      window.__veDragging = false;
    }
    if (typeof document !== "undefined") {
      document.body.classList.remove("veFeatureDragging");
    }
    featureDragStore.draggingFeatureId = null;
    featureDragStore.draggingHandle = null;
    featureDragStore.dragCaretPosition = null;
    if (dragHasMoved) {
      const updatedFeature = {
        ...annotation,
        start: lastStart,
        end: lastEnd,
        ...annotation.locations && annotation.locations.length === 1 && {
          locations: [
            { ...annotation.locations[0], start: lastStart, end: lastEnd }
          ]
        }
      };
      upsertFeature(updatedFeature, { batchUndoEnd: true });
    }
  };
  if (typeof window !== "undefined") {
    window.addEventListener("mousemove", onMouseMove, true);
    window.addEventListener("mouseup", onMouseUp, true);
  }
}
